import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Report } from '@classes/report';
import { ReportType } from '@classes/report-type';
// import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  environment = this.envConfigurationService.environment;

  private basePathReport = this.environment.apiUrl + '/report';
  private basePathReportType = this.environment.apiUrl + '/reporttype';

  constructor(
    private http: HttpClient,
    public envConfigurationService: EnvConfigurationService
  ) { }

  getReportTypes(): Observable<Array<ReportType>> {
    return this.http.get<Array<ReportType>>(this.basePathReportType);
  }

  getReport(report: Report): Observable<any> {
    return this.http.post(this.basePathReport, report,
      {
        observe: 'response',
        responseType: 'blob',
      });
  }

  buildHttpParams(params: any, data: any, currentPath: string) {
    Object.keys(data).forEach(key => {
      if (data[key] instanceof Object && data[key] != null) {
        this.buildHttpParams(params, data[key], `${currentPath}${key}.`);
      } else if (data[key] != null) {
        params[`${currentPath}${key}`] = data[key];
      }
    });
  }

  public downloadBlob(fileName: string, blob: Blob): void {
    // if (window.navigator.msSaveOrOpenBlob) {
    //   window.navigator.msSaveBlob(blob, fileName);
    // } else {
    const anchor = window.document.createElement('a');
    anchor.href = window.URL.createObjectURL(blob);
    anchor.download = fileName;
    document.body.appendChild(anchor);
    anchor.click();
    document.body.removeChild(anchor);
    window.URL.revokeObjectURL(anchor.href);
    // }
  }
}
